"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Copyright = _interopRequireDefault(require("../Copyright/Copyright"));
var _useBreakPoint = require("../../../common/useBreakPoint");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.picture-container img {\n  height: auto;\n  width: 100%;\n  object-fit: cover; }\n\n.picture-container .copyright-container p {\n  padding-left: 0px; }\n";
  const fileName = "PagePicture_PagePicture";
  const element = document.querySelector("style[data-sass-component='PagePicture_PagePicture']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const PagePicture = _ref => {
  let {
    src,
    srcTablet,
    srcMobile,
    copyright,
    aspectRatio
  } = _ref;
  const {
    isDesktop,
    isTablet
  } = (0, _useBreakPoint.useBreakPoint)();
  const finalSrc = isDesktop ? src : isTablet ? srcTablet || src : srcMobile || srcTablet || src;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: `picture-container ${copyright ? 'sia-padding-04-bottom' : 'sia-padding-05-bottom'}`
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: finalSrc,
    style: {
      aspectRatio: aspectRatio,
      color: 'red'
    }
  }), copyright && /*#__PURE__*/_react.default.createElement(_Copyright.default, copyright)));
};
PagePicture.propTypes = {
  src: _propTypes.default.string.isRequired,
  copyright: _propTypes.default.object,
  aspectRatio: _propTypes.default.string
};
PagePicture.defaultProps = {};
var _default = exports.default = PagePicture;